import React from "react";

interface InfoRowProps {
  label: string;
  value: React.ReactNode;
  bold?: boolean;
  className?: string;
}

/** 
 * Reusable label/value row (used in dialogs, summaries, etc.)
 */
const InfoRow: React.FC<InfoRowProps> = ({ label, value, bold, className }) => {
  return (
    <div className={`flex justify-between mb-3 ${className || ""}`}>
      <p className="font-semibold text-gray-800">{label}</p>
      <p className={bold ? "font-bold text-gray-900" : "text-gray-700"}>
        {value}
      </p>
    </div>
  );
};

export default InfoRow;
